/* eslint-disable react/prop-types */

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import clsx from 'clsx';

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>>(
    ({ className, ...props }, ref) => (
        <SliderPrimitive.Root ref={ref} className={clsx('relative flex w-full touch-none select-none items-center', className)} {...props}>
            <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-gray-100">
                <SliderPrimitive.Range className="absolute h-full bg-primary" />
            </SliderPrimitive.Track>
            <label className="absolute left-0 top-full text-xs text-contentSecondary">{props.min}</label>
            <label className="absolute right-0 top-full text-xs text-contentSecondary">{props.max}</label>
            <SliderPrimitive.Thumb className="relative block h-4 w-4 rounded-full border border-primary/50 bg-primary shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50">
                <div className="absolute bottom-full bg-primary text-white text-sm rounded-sm py-0.5 px-1.5 left-1/2 -translate-x-1/2 mb-1">
                    {props.value?.[0]}
                </div>
            </SliderPrimitive.Thumb>
        </SliderPrimitive.Root>
    )
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
